<template>
  <div class="app">
    <NuxtLayout>
      <div class="app-page">
        <NuxtPage :keepalive="keepalive" />
      </div>
    </NuxtLayout>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted } from "vue";
import { bpV2, getNativeAbValue, getUserInfoVal, hiddenTitle, setStatusShow } from "./utils/jsb";
import { getBlackbox } from "~/utils";

// 须与各页 definePageMeta({ name }) 完全一致（区分大小写）。max 避免 LRU 把列表页挤出缓存导致从详情返回整页重挂载。
const keepalive = {
  include: ["Goodslist", "goodslist", "goodssearch"],
  max: 20
};
/**
 * @description 修改根节点字体大小
 * @return {void}
 */
const setRem = () => {
  const width = document.documentElement.clientWidth;
  const rem = width / 16;
  document.documentElement.style.fontSize = rem + "px";
};


const loading = ref(true);
onMounted(async () => {
  setRem();
  loading.value = false;
  setStatusShow(false);
  
  // meta-pay-sdk 环境回调函数挂载（必须在应用初始化时尽早挂载）
  window.refreshUI = () => {
  };
  window.nativeLogin = () => {
    // 登录成功后的回调，可以在这里处理刷新用户信息等逻辑1
  };
  window.backToWeb = () => {
    setStatusShow(false);
  };
  sessionStorage.setItem("activeTab", "0");
  sessionStorage.setItem("activeGame", "0");
  if (window.addEventListener) {
    window.addEventListener("resize", setRem);
  } else if (window.attachEvent) {
    window.attachEvent("onresize", setRem);
  }
  const sessionId =
    "changyo-pc-" + new Date().getTime() + "-" + Math.random().toString(16).slice(2);
  sessionStorage.setItem("sessionId", sessionId);
  hiddenTitle();
  const baseParams = await bpV2();
  const paramsObj = {
    Authorization: "",
    appVersionCode: ""
  };

  sessionStorage.setItem("baseParams", JSON.stringify(baseParams || paramsObj));
  const userInfo = await getUserInfoVal();
  sessionStorage.setItem("userInfo", JSON.stringify(userInfo || {}));
  getNativeAbValue().then((data) => {
    sessionStorage.setItem("is_improve_account", data ? "true" : "false");
  });
  pandora.send('','',{})
  if(window && window.navigator.userAgent.includes("meta-pay-sdk")){
    jsb?.execSync("setNativeTitleShow", false);
  }
});



</script>

<style scoped lang="scss">
* {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu",
  "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
}

.app {
  width: 100vw;
  height: calc(100vh - 1.6rem);
  transform: translateY(1.6rem);
  position: relative;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;

  .app-page {
    width: 100vw;
  }

  .app-loading {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>
